module.exports = __webpack_public_path__ + "static/media/logo.068d233c.svg";